/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Last_NameInputs */

const cs_form_last_name = /** @type {(inputs: Form_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příjmení`)
};

const en_form_last_name = /** @type {(inputs: Form_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Form_Last_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_last_name = /** @type {((inputs?: Form_Last_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Last_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_last_name(inputs)
	return cs_form_last_name(inputs)
});